// An ampersand already starting a character reference is left alone, so a value escaped once can be escaped again
// without changing. The stored introduction arrives here pre-escaped, and escaping its entities a second time would
// serve the entity text itself rather than the character it stands for.
const BARE_AMPERSAND = /&(?![a-zA-Z][a-zA-Z0-9]*;|#\d+;|#x[\da-fA-F]+;)/g;

/**
 * Escapes characters that are unsafe in HTML attribute values. Required because Quasar's useMeta plugin does not escape
 * attribute content during SSR, so characters like double quotes in meta descriptions break the rendered HTML.
 *
 * Only escapes during SSR; on the client the DOM handles attribute escaping natively via setAttribute.
 *
 * @param {string} text - The text to escape.
 * @returns {string} - The escaped text during SSR, or the original text on the client.
 */
export function escapeMetaContent(text) {
    if (!text || !import.meta.env.QUASAR_SERVER) {
        return text;
    }
    return text
        .replace(BARE_AMPERSAND, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
